export default __webpack_public_path__ + "static/37-f83b8eb51a5cb9ddd5ee5e0c4da4161c.png";